import { render, staticRenderFns } from "./PhantomStock.vue?vue&type=template&id=5e1ccd46&"
import script from "./PhantomStock.vue?vue&type=script&lang=js&"
export * from "./PhantomStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QToggle,QSelect,QCard,QCardSection,QScrollArea,QBadge,QSpinner,QInput,QSpace,QSlider,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QToggle,QSelect,QCard,QCardSection,QScrollArea,QBadge,QSpinner,QInput,QSpace,QSlider,QBtn})
